export enum AppEnv {
  Mock = 'mock',
  Dev = 'dev',
  QA = 'qa',
  Uat = 'uat',
  EngProd = 'engprod',
  Prod = 'prod',
}

export enum PiTargetBg {
  Default = 'default',
  Blue = 'blue',
  Green = 'green',
  UAT = 'uat',
  EngProd = 'engprod',
  QA = 'qa',
}

// https://prism.spectruminternal.com/SpectrumEnterpriseNet@Web/quantum-resources/event-cases/SpectrumEnterpriseNet_startSession_generic/portals
export interface IAppConfigQuantumConfig {
  readonly domain: string;
  readonly appName: string;
  readonly appVersion: string;
  readonly packageVersion: string;
  readonly requirementsVersion: string;
  readonly appEnvName: string;
  readonly startSession: string;
}

export interface IAppConfigApiHosts {
  /** PiNxt Gateway host to access APIs in Backend */
  readonly piHost: string;
  /** Direct API Backend host thats behind PiNxt Gateway   */
  readonly directHost: string;
}

export interface IAppConfig {
  /** Whether or not the app environment is a prod based environment.  */
  readonly isProd: boolean;

  /** Whether or not the app environment is the true, public facing, production environment. */
  readonly isTrueProd: boolean;

  /** Whether or not the app environment is a mock based environment. */
  readonly isMock: boolean;

  /** Whether or not the app is running locally */
  readonly isLocal: boolean;

  readonly app: {
    /** Short App name or abbreviation  */
    readonly shortName: string;

    /** Full app name in proper Title Case.  Used in page titles, etc. */
    readonly displayName: string;

    /** The environment the application is running as */
    readonly env: AppEnv;

    /** The current application version  */
    readonly version: string;
  };

  readonly api: {
    readonly useDirectHost: boolean;
    readonly auth: string;
    readonly graphql: string;
    readonly restEndpoint: string;
    readonly piHost: string;
  };

  readonly analytics: {
    readonly quantum: {
      readonly enabled: boolean;
      readonly devEndpoint: string;
      readonly prodEndpoint: string;

      readonly config: IAppConfigQuantumConfig;
    };

    readonly adobe: {
      readonly enabled: boolean;
      readonly devEndpoint: string;
      readonly prodEndpoint: string;
    };
  };

  readonly auth: {
    readonly targetBg: PiTargetBg;
    readonly loginUrl: string;
    readonly loginParams: string;
    /** post logged out url / path to send the user to */
    readonly logoutUrl: string;
    readonly piClientId: string;
    readonly autoLogout: {
      /** The number of mins the user must remain idle until the session expires */
      readonly timeoutMins: number;

      /** The number of mins BEFORE the timeout to show a warning prompt before logging them out */
      readonly preTimeoutWarnMins: number;
    };
  };

  readonly tdcs: {
    readonly enabled: boolean;
    readonly apiKey: string;
    readonly host: string;
    readonly config: {
      readonly appVersion: string;
      readonly clientType: string;
      readonly deviceId: string;
      readonly osVersion: string;
      readonly deviceType: string;
    };
    readonly localConfig: string; // for local development only
  };

  // Access Google API library
  readonly google: {
    readonly siteKey: string;
  };

  readonly datadog: {
    readonly host: string;
    readonly applicationId: string;
    readonly env: string | undefined;
  };
}
